import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_4 = { "aria-label": "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb mb-0" }
const _hoisted_6 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_7 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_8 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active uppercase-text"
}
const _hoisted_9 = { class: "card" }
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "accordion-wrap mt-4" }
const _hoisted_13 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = { class: "card-body border-0" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "text-right" }
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "accordion-wrap mt-4" }
const _hoisted_24 = {
  class: "accordion",
  id: "accordionExample1"
}
const _hoisted_25 = { class: "mb-0" }
const _hoisted_26 = { class: "card-body border-0" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_33 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('frequently_asked_questions')), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("nav", _hoisted_4, [
          _createVNode("ol", _hoisted_5, [
            _hoisted_6,
            _createVNode("li", _hoisted_7, [
              _createVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('faq')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("p", null, _toDisplayString(_ctx.$t('email_contact1')), 1),
      (_ctx.state.faqList.length)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.splitFaq.firstHalf, (faq, faqIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "card rounded mb-2 p-0",
                      key: faqIndex
                    }, [
                      _createVNode("div", {
                        class: "card-header bg-white p-0 border-0",
                        id: `headingOne${faqIndex }`
                      }, [
                        _createVNode("h2", _hoisted_14, [
                          _createVNode("button", {
                            class:  faqIndex===0?'btn btn-link btn-block text-left':'btn btn-link btn-block text-left collapsed',
                            type: "button",
                            "data-toggle": "collapse",
                            "data-target": `#collapseOne${faqIndex }`,
                            "aria-expanded": "true",
                            "aria-controls": `#collapseOne${faqIndex }`
                          }, _toDisplayString(faq.question), 11, ["data-target", "aria-controls"])
                        ])
                      ], 8, ["id"]),
                      _createVNode("div", {
                        id: `collapseOne${faqIndex }`,
                        class: faqIndex===0?'collapse show':'collapse',
                        "aria-labelledby": `headingOne${faqIndex }`,
                        "data-parent": "#accordionExample"
                      }, [
                        _createVNode("div", _hoisted_15, [
                          _createVNode("div", {
                            innerHTML: faq.answer
                          }, null, 8, ["innerHTML"]),
                          _createVNode("div", _hoisted_16, [
                            _createVNode("div", _hoisted_17, [
                              (faq.file)
                                ? (_openBlock(), _createBlock("a", {
                                    key: 0,
                                    href: faq.file,
                                    class: "btn default-btn d-inline-block mr-2 mt-3",
                                    target: "_blank"
                                  }, [
                                    _hoisted_18,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download_pdf')), 1)
                                  ], 8, ["href"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_19, [
                              _createVNode("div", _hoisted_20, [
                                (faq.url)
                                  ? (_openBlock(), _createBlock("a", {
                                      key: 0,
                                      href: faq.url,
                                      class: "btn default-btn primary-btn d-inline-block mt-3",
                                      target: "_blank"
                                    }, [
                                      _hoisted_21,
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('watch_tutorial')), 1)
                                    ], 8, ["href"]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ], 10, ["id", "aria-labelledby"])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.splitFaq.secondHalf, (faq, faqIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "card rounded mb-2 p-0",
                      key: faqIndex
                    }, [
                      _createVNode("div", {
                        class: "card-header bg-white p-0 border-0",
                        id: `headingOne1${faqIndex }`
                      }, [
                        _createVNode("h2", _hoisted_25, [
                          _createVNode("button", {
                            class: faqIndex===0?'btn btn-link btn-block text-left':'btn btn-link btn-block text-left collapsed',
                            type: "button",
                            "data-toggle": "collapse",
                            "data-target": `#collapseOne1${faqIndex}`,
                            "aria-expanded": "true",
                            "aria-controls": `#collapseOne1${faqIndex }`
                          }, _toDisplayString(faq.question), 11, ["data-target", "aria-controls"])
                        ])
                      ], 8, ["id"]),
                      _createVNode("div", {
                        id: `collapseOne1${faqIndex }`,
                        class: faqIndex===0?'collapse show':'collapse',
                        "aria-labelledby": `headingOne1${faqIndex}`,
                        "data-parent": "#accordionExample1"
                      }, [
                        _createVNode("div", _hoisted_26, [
                          _createVNode("div", {
                            innerHTML: faq.answer
                          }, null, 8, ["innerHTML"]),
                          _createVNode("div", _hoisted_27, [
                            _createVNode("div", _hoisted_28, [
                              (faq.file)
                                ? (_openBlock(), _createBlock("a", {
                                    key: 0,
                                    href: faq.file,
                                    class: "btn default-btn d-inline-block mr-2 mt-3",
                                    target: "_blank"
                                  }, [
                                    _hoisted_29,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download_pdf')), 1)
                                  ], 8, ["href"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_30, [
                              _createVNode("div", _hoisted_31, [
                                (faq.url)
                                  ? (_openBlock(), _createBlock("a", {
                                      key: 0,
                                      href: faq.url,
                                      class: "btn default-btn primary-btn d-inline-block mt-3",
                                      target: "_blank"
                                    }, [
                                      _hoisted_32,
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('watch_tutorial')), 1)
                                    ], 8, ["href"]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ], 10, ["id", "aria-labelledby"])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_33, [
            _createVNode(_component_EmptyData, {
              title: _ctx.state.data.title,
              heading: _ctx.state.data.heading
            }, null, 8, ["title", "heading"])
          ]))
    ])
  ]))
}